import { useMutation, useQueryClient } from '@tanstack/react-query';
import { raiseTicket } from '../../../../services/tickets/users';
import { ticketsQueryKeys } from './useTicketsQuery';

export function useRaiseTicket({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: raiseTicket,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ticketsQueryKeys.all });
      onSuccess?.(data, variables);
    },
    onError,
  });
}
